
<div>
    <div class="image">
        <img v-if="item.image" :src="item.image.public_path" class="img-fluid" :alt="item.image.alt" width="400" height="300"/>
    </div>

    <div class="body">
        <h4>{{ item.title }}</h4>
        <div v-html="item.blurb"></div>

        <a class="btn btn-danger d-flex flex-nowrap align-items-center" :href="`blog/${item.slug}`"><span class="pe-3">{{btnText}}</span> <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18"></a>
    </div>
</div>
